import { readBrowserPublicRuntimeConfig } from "../runtime-config/public-runtime-config";
import { normalizeStripePublishableKey } from "./publishable-key";

function getStripePublishableKey(): string | null {
  return normalizeStripePublishableKey(
    readBrowserPublicRuntimeConfig().stripePublishableKey,
  );
}

export { getStripePublishableKey, normalizeStripePublishableKey };
